var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h4 text-center py-5"},[_vm._v(" Данный функционал находится на этапе разработки ")])}
var staticRenderFns = []

export { render, staticRenderFns }